module.exports = __webpack_public_path__ + "static/media/log-out-3.23dcae6f.svg";